module.exports = "<div style=\"padding:5px\">\n    <img [src]=\"temp\" alt=\"\" style=\"height:440px; width:490px\">\n   </div>"